/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档

  
    
export interface IAPI76182ResListItem {
  
  /** 用户id */
  userId?: string;
  
  /** 头像 */
  headImg?: string;
  
  /** 用户昵称 */
  nickName?: string;
  
  /** 真实名称 */
  realName?: string;
  
  /** from：aito:用户 */
  userType?: string;
  
};
    
  



export type API76182Req = {};



export interface API76182Res {
  /** T  */
  list?: IAPI76182ResListItem[];
  /**   */
  totalNumber?: number;
  /**   */
  totalPage?: number;
  /**   */
  rowId?: string;
  /**   */
  hasNext?: boolean;
  /**   */
  pageSize?: number;
  /**   */
  pageIndex?: number;
  
};


// 接口函数 76182 执行人列表

export interface IUseGetAPI76182Return {
  /** 执行人列表: 接口请求状态 */
  isAPI76182Loading: boolean;
  /** 执行人列表: 接口请求返回数据 */
  dataAPI76182: API76182Res;
  /**  执行人列表: 接口数据请求方法 */
  fetchAPI76182Data: ( config?: YWRequestConfig) => Promise<API76182Res>;
  /** 执行人列表: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI76182 = ():IUseGetAPI76182Return => {
  let isMount = true;
  const [isAPI76182Loading, setIsAPI76182Loading] = useState(false);
  const [dataAPI76182, setDataAPI76182] = useState<API76182Res>({} as API76182Res);
  const requestUrl = `${basePath}/yoaichat-web/task/instance/executor/list`;

  const fetchAPI76182Data = async ( config?: YWRequestConfig): Promise<API76182Res> => {
  
    if ( isMount ) {
      setIsAPI76182Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API76182Res>(`${basePath}/yoaichat-web/task/instance/executor/list`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI76182(res || {} as API76182Res);
        setIsAPI76182Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI76182Loading(false);
      }
      return false as unknown as API76182Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI76182Loading,
    dataAPI76182,
    fetchAPI76182Data,
    requestUrl,
  }
}

